import React from 'react';

import Layout from 'components/Common/Layout';
import LoadingOverlay from 'components/Common/LoadingOverlay';

export default () => (
  <Layout>
    <LoadingOverlay />
  </Layout>
);
